// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonLabels = {
  empty: "-",
  none: "None",
  loading: "Loading...",
  total: "Total",
  archived: "Archived",
  hidden: "Hidden",
  emptyText: "(Empty)",
  avatarAlt: "Avatar",
  versionTag: "V1",
  nonePaper: "No paper",
  uncategorized: "Uncategorized",
  notSet: "Not set",
  noData: "No data",
  pleaseSelect: "Please select",
  online: "Online",
  offline: "Offline",
} as const;
